import { render, staticRenderFns } from "./CarouselEdit.vue?vue&type=template&id=2517440a&"
import script from "./CarouselEdit.vue?vue&type=script&lang=js&"
export * from "./CarouselEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2517440a')) {
      api.createRecord('2517440a', component.options)
    } else {
      api.reload('2517440a', component.options)
    }
    module.hot.accept("./CarouselEdit.vue?vue&type=template&id=2517440a&", function () {
      api.rerender('2517440a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/carousel/CarouselEdit.vue"
export default component.exports